<template>
  <div class="live-checklist-wrapper">
    <div class="completeness-bar" v-if="itemsCount != null ">
      <div class="progress">
        <div v-if="itemsCount > 0" class="progress-bar bg-success" role="progressbar" :style="{ width: progress }">
          <div class="value-wrapper">{{ progress }} {{ $t('checklist.complete') }}</div>
        </div>
        <div v-if="itemsCount > 0 && progress === '0%'" class="progress-bar bg-neutral" role="progressbar">
          <div class="value-wrapper">{{ progress }} {{ $t('checklist.complete') }}</div>
        </div>
        <div class="progress-bar empty-checklist" v-if="itemsCount === 0">
          <b>{{ $t('checklist.empty_checklist') }}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['itemsCount', 'completedItemsCount'],
    computed: {
      progress() {
        if (this.$props.itemsCount == 0)
          return '0%'

        return (this.$props.completedItemsCount / this.$props.itemsCount * 100).toFixed(1) + '%'
      },
    },
  }
</script>
